<template>
  <div class="section-white full-page">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <template>
            <h5>Regulamin dla Kont LIBRUS</h5>
            <h6>
              <a
                class="link-lightblue"
                href="https://portal.librus.pl/dokumenty/regulamin-portalu-rodzina-1-5"
                >Regulamin dla Kont Librus</a
              >
            </h6>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RulesView",
  data() {
    return {
      targetData: "2025-07-31T08:00:00.000+02:00",
    };
  },
  computed: {
    isDateEqual() {
      const currentDate = new Date();
      const targetDate = new Date(this.targetData);
      return currentDate >= targetDate;
    },
  },
  created() {
    this.$emit("showFaqHeader", false);
  },
  mounted() {
    document.title = "Regulamin Konto Librus";
  },
};
</script>
<style scope>
body main {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 63px);
}
.full-page {
  flex: 1;
}
@media screen and (max-width: 991px) {
  body main {
    min-height: calc(100vh - 57px);
  }
}
</style>
